import { render, staticRenderFns } from "./HelpListEdit.vue?vue&type=template&id=f98c94de&"
import script from "./HelpListEdit.vue?vue&type=script&lang=js&"
export * from "./HelpListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports